import React from "react";
import { Link } from "react-router-dom";
import "../../common/bg.css";
import "./c.css";
import WebsiteName from "../../common/WebsiteName/WebsiteName";
import Navbar from "../../common/Navbar/NavBar";
import Location from "../../common/Location/Location";
import Footer from "../../common/Footer/Footer";
export default function C_info() {
  return (
    <>
      <section className="bgImageCommon">
        <WebsiteName />
        <Navbar />
        <Location title="JAVA" />
        <section>
          <div className="cBody">
            <div id="cardDIV">
              <h1 className="text-dark" id="laguage_Title">
                JAVA
              </h1>
              <p className="text-secondary" id="Language_Para">
                Java is a widely used object-oriented programming language and
                software platform that runs on billions of devices, including
                notebook computers, mobile devices, gaming consoles, medical
                devices and many others. The rules and syntax of Java are based
                on the C and C++ languages. One major advantage of developing
                software with Java is its portability. Once you have written
                code for a Java program on a notebook computer, it is very easy
                to move the code to a mobile device.
                <br />
                When the language was invented in 1991 by James Gosling of Sun
                Microsystems (later acquired by Oracle),
                <br />
                The primary goal was to be able to "write once, run anywhere."
                It's also important to understand that Java is much different
                from JavaScript. Javascript does not need to be compiled, while
                Java code does need to be compiled. Also, Javascript only runs
                on web browsers while Java can be run anywhere. New and improved
                software development tools are coming to market at a remarkable
                pace, displacing incumbent products once thought to be
                indispensable. In light of this continual turnover, Java’s
                longevity is impressive; more than two decades after its
                creation, Java is still the most popular language for
                application software development—developers continue to choose
                it over languages such as Python, Ruby, PHP, Swift, C++, and
                others. As a result, Java remains an important requirement for
                competing in the job market.
              </p>
              <Link
                name=""
                id=""
                class="btn btn-danger"
                to="/Courses"
                role="button">
                {"<< "}back
              </Link>
            </div>
          </div>
        </section>
        <Footer />
      </section>
    </>
  );
}
